/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  fileUtil.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * 获取base64编码
 * @param imgFile
 */
export function getBase64(imgFile: File) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    reader.readAsDataURL(imgFile);
  });
}

/**
 * js导出文件
 * @param content
 * @param filename
 */
export function exportFile (content, filename) {
  // 字符内容转变成blob地址
  const blob = new Blob([content])
  if ('msSaveOrOpenBlob' in navigator) { // IE导出
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    // 创建隐藏的可下载链接
    const eleLink = document.createElement('a')
    eleLink.download = filename
    eleLink.style.display = 'none'
    eleLink.href = URL.createObjectURL(blob)
    // 触发点击
    document.body.appendChild(eleLink)
    eleLink.click()
    // 然后移除
    document.body.removeChild(eleLink)
  }
}

/**
 * 获取文件名称
 * @param contentPosition
 */
export function getFileName(contentPosition: string) {
  let fileName = contentPosition.split(";")[1].split("filename=")[1];
  let fileNameUnicode = contentPosition.split("filename*=")[1];
  if (fileNameUnicode) {
    // 当存在 filename* 时，取filename* 并进行解码（为了解决中文乱码问题）
    fileName = decodeURIComponent(fileNameUnicode.split("''")[1]);
  }
  return decodeURIComponent(fileName);
}
